<script setup lang="ts">
import { computed } from "vue";

enum ColorClass {
  default = "bg-secondary hover:bg-primary text-white",
  red = "bg-link-red hover:bg-red-700 text-white",
  amber = "bg-amber-500 hover:bg-amber-700 text-white",
  transparent = "bg-transparent text-link-blue hover:bg-link-blue hover:text-white border-link-blue",
  "transparent-red" = "bg-white text-link-red hover:bg-red-700 hover:text-white border-link-red",
  green = "bg-link-green text-white",
  disabled = "bg-gray-400 text-white",
}

enum BorderlessColorClass {
  default = "bg-secondary hover:bg-primary text-white",
  red = "bg-link-red hover:bg-red-700 text-white",
  amber = "bg-amber-500 hover:bg-amber-700 text-white",
  transparent = "bg-transparent text-link-blue hover:underline",
  "transparent-red" = "bg-transparent text-link-red hover:underline",
  green = "bg-link-green hover:bg-green-700 text-white ",
  disabled = "bg-gray-400 text-white",
}

type Props = {
  color?: keyof typeof BorderlessColorClass | keyof typeof ColorClass;
  icon?: string;
  iconPosition?: "left" | "right";
  border?: boolean;
  disabled?: boolean;
  tabindex?: string;
  badgeCount?: number;
};

const props = withDefaults(defineProps<Props>(), {
  color: "default",
  border: false,
  disabled: false,
  iconPosition: "left",
});

const classes = computed(() => {
  if (props.border) {
    if (props.disabled) {
      return ColorClass["disabled"];
    } else {
      return ColorClass[props.color as keyof typeof ColorClass];
    }
  } else if (props.disabled) {
    return BorderlessColorClass["disabled"];
  } else {
    return BorderlessColorClass[
      props.color as keyof typeof BorderlessColorClass
    ];
  }
});
</script>

<template>
  <button
    class="relative inline-flex items-center justify-center gap-x-2 rounded px-4 py-1 font-medium focus:outline-none"
    :class="`${classes} ${props.border ? 'border' : ''}`"
    :disabled="props.disabled"
    :tabindex="props.tabindex"
  >
    <template v-if="iconPosition === 'left'">
      <font-awesome-icon v-if="icon" :icon="icon" /><slot
    /></template>
    <template v-else
      ><slot /><font-awesome-icon v-if="icon" :icon="icon"
    /></template>
    <p
      v-if="badgeCount"
      class="flex justify-center items-center absolute bottom-3 -right-3 rounded-full text-sm w-6 h-6 text-white bg-link-red"
    >
      {{ badgeCount }}
    </p>
  </button>
</template>
